export {};

declare global {
    interface Map<K, V> {
        objeto(): any;
    }
}

Map.prototype.objeto = function(): any {
    const convMap = {};
    this.forEach((val: string, key: string) => {
        convMap[key] = val;
    });
    return convMap;
};
